import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import "./Home.css";
import resume from "../about/data/resume.pdf";

// motion variants:
const mainSectionVariants = {
  hidden: { y: "5%", opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.75,
      type: "tween",
    },
  },
};

const Home = ({ setPageTitle }) => {
  // Using the useNavigate hook to navigate to other pages
  const navigate = useNavigate();

  useEffect(() => {
    // Setting the page title
    setPageTitle(["Home", " Page"]);
    window.scrollTo(0, 0);
  }, [setPageTitle]);

  return (
    // Section for the home page
    <section className="homePage-container">
      <motion.main
        variants={mainSectionVariants}
        initial="hidden"
        animate="visible"
        className="main-container"
      >
        <p className="paragraph">
          <span className="highlighted">Hi, my name is</span>
        </p>

        {/* Container for the headings */}
        <div className="headings">
          <h1 className="heading">Naimur Rahman.</h1>

          <h2 className="heading faded">I build things behind the web.</h2>
        </div>

        <article className="paragraph">
          <span className="highlighted">
            Backend Developer versed in Django, FastAPI, PostgreSQL, and
            automation frameworks.
          </span>{" "}
          I build Python backend systems, Django applications, and automation
          workflows. I am based in Bangladesh and open to international remote
          backend and automation roles.
        </article>

        <div className="home-actions">
          <button
            className="btn"
            onClick={() => {
              navigate("contact");
              setPageTitle(["Get In", " Touch"]);
            }}
          >
            {/* Button to navigate to the contact page */}
            <span className="highlighted">Get In Touch</span>
          </button>
          <a className="btn" href={resume} download="Resume of Naimur Rahman">
            <span className="highlighted">Resume</span>
          </a>
        </div>
      </motion.main>
    </section>
  );
};

export default Home;
